// extracted by mini-css-extract-plugin
export default {"iframeLinkWrap":"src-components-Modules-revamp-FieldLinkLibrary-css-module__iframeLinkWrap--3cziw"};